import { Link } from "react-router-dom";

const Missing = () => {

  const Refund_Cancellation = {
    title: "Refund & Cancellation Policy",
    points: [
      "Payments made through the online portal are non-refundable and non-adjustable.",
      "No request for cancellation of application or refund shall be entertained after successful payment.",
      "Applicants are advised to carefully verify all particulars, documents, and details before making payment. Once paid, the amount shall be treated as final.",
      "Refund of fee shall be considered only in cases of technical failure, where the amount is debited from the applicant’s bank account but the transaction is not reflected on the portal, subject to verification and approval by the Competent Authority."
    ],
    contact: {
      label: "For transaction-related issues, please contact:",
      email: "refund.help2026@gmail.com"
    }
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundColor: "#c0edd8",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    padding: "20px"
  };

  const contentStyle = {
    textAlign: "center",
    padding: "40px",
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    maxWidth: "700px",
    width: "100%",
  };

  const headingStyle = {
    fontSize: "72px",
    color: "#dc3545",
    marginBottom: "10px",
    fontWeight: "bold",
  };

  const subheadingStyle = {
    fontSize: "24px",
    color: "#333333",
    marginBottom: "20px",
  };

  const paragraphStyle = {
    fontSize: "16px",
    color: "#666666",
    marginBottom: "20px",
  };

  const policyTitle = {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "15px",
    color: "#007bff"
  };

  const listStyle = {
    textAlign: "left",
    marginBottom: "20px",
    paddingLeft: "20px",
    color: "#444"
  };

  const linkStyle = {
    display: "inline-block",
    padding: "12px 24px",
    backgroundColor: "#007bff",
    color: "#ffffff",
    textDecoration: "none",
    borderRadius: "6px",
    fontWeight: "bold",
    transition: "background-color 0.3s ease",
    marginTop: "20px"
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>


        {/* Refund Policy Section */}
        <div style={policyTitle}>{Refund_Cancellation.title}</div>

        <ul style={listStyle}>
          {Refund_Cancellation.points.map((item, index) => (
            <li key={index} style={{ marginBottom: "10px" }}>
              {item}
            </li>
          ))}
        </ul>

        <p style={paragraphStyle}>
          <strong>{Refund_Cancellation.contact.label}</strong><br />
          📧 {Refund_Cancellation.contact.email}
        </p>

        {/* Home Button */}
        <Link
          to="/"
          style={linkStyle}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
        >
          Go to Homepage
        </Link>

      </div>
    </div>
  );
};

export default Missing;